<div class="">
  <div class="" *ngIf="page.total > 0" style="border-bottom: 1px solid var(--card-border-colour)">
    <p-table
      #dt
      [value]="page.items"
      [totalRecords]="page.total"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      [sortField]="filter.sortField"
      [sortOrder]="filter.sortOrder"
      [rows]="filter.rows"
      [first]="filter.first"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [styleClass]="'no-border-table'"
      tableStyleClass="table-no-top-corners"
      [loading]="loading"
      [resizableColumns]="true"
      [responsive]="true"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="opened">Opened</th>
          <th pSortableColumn="closed">Closed</th>
          <th pSortableColumn="dueBy">Due By Date</th>
          <th pSortableColumn="assigneeName">Assignee</th>
          <th pSortableColumn="vehicleReg">Vehicle</th>
          <th pSortableColumn="comment">Incident</th>
          <th pSortableColumn="closureReason">Closure Reason</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <div [title]="getDateDescription(item.opened)">
              {{ getDateDescription(item.opened) }}
            </div>
          </td>
          <td>
            <div [title]="getDateDescription(item.closed)">
              {{ getDateDescription(item.closed) }}
            </div>
          </td>
          <td>
            <div [title]="getDateDescription(item.dueBy)">
              {{ getDateDescription(item.dueBy, true) }}
            </div>
          </td>
          <td>
            <div [title]="item.assigneeName || 'Assign to me'">
              <ng-container *ngIf="!item.closed; else assigneeNameRaw">
                <ng-container
                  *ngIf="item.assigneeId; then assigneeAnchor; else assignToMeAnchor"
                ></ng-container>
                <ng-template #assigneeAnchor>
                  <a [routerLink]="[]" (click)="openAssigneeSelectionPanel($event, item)">{{
                    item.assigneeName
                  }}</a>
                </ng-template>
                <ng-template #assignToMeAnchor>
                  <a [routerLink]="[]" (click)="assignToMe(item)">Assign to me</a>
                </ng-template>
              </ng-container>
              <ng-template #assigneeNameRaw>{{ item.assigneeName }}</ng-template>
            </div>
          </td>
          <td>
            <div [title]="item.vehicleReg">
              {{ item.vehicleReg }}
            </div>
          </td>
          <td>
            <div pTooltip="{{ item.comment }}">
              {{ item.typeName || 'N/A' }}
            </div>
          </td>
          <td>
            <div
              *ngIf="item.closureReason"
              pTooltip="{{ item.closureNotes }}"
              tooltipPosition="left"
            >
              {{ item.closureReason.reason }}
            </div>
          </td>
          <td>
            <a
              class="close-incident"
              *ngIf="!item.closed && currentUserId == item.assigneeId"
              (click)="closeIncident(item)"
              >Close</a
            >
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="px-3 py-3">
  <form
    class="incident-form-container"
    [formGroup]="raiseIncidentsForm"
    (ngSubmit)="raiseIncident()"
  >
    <div class="flex flex-wrap grid-gap-15 style2023">
      <div class="flex-grow-1" style="max-width: 300px">
        <div class="input-group">
          <div class="input-group-item">
            <p-dropdown
              placeholder="Incident Type"
              formControlName="typeId"
              class="dropdown-narrow-1 input-border-1"
              [options]="typeOpts"
              [autoDisplayFirst]="false"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="flex-grow-1">
        <div class="input-group input-border-1">
          <div class="input-group-item">
            <input formControlName="comment" pInputText placeholder="Comment..." class="w-100" />
          </div>
        </div>
      </div>
      <div class="flex-grow-1">
        <div class="input-group input-border-1">
          <div class="input-group-item">
            <p-calendar
              formControlName="dueBy"
              placeholder="Due By..."
              dateFormat="dd/mm/yy"
              [minDate]="currentDate"
            ></p-calendar>
          </div>
        </div>
      </div>
      <div class="flex-shrink-1">
        <button
          pButton
          type="submit"
          label="Raise Incident"
          class="btn btn-mobile-block"
          [disabled]="raiseIncidentsForm.invalid"
        ></button>
      </div>
    </div>
  </form>
</div>

<p-overlayPanel #assigneeSelectionPanel (onHide)="onAssigneeSelectionPanelHide()">
  <div class="ui-g">
    <div class="ui-g-12 align-center">
      <a [routerLink]="[]" (click)="confirmAssigneeSelection()">Assign to me</a>
    </div>
    <div class="ui-g-12 align-center">
      <a [routerLink]="[]" (click)="assigneeSelectionPanel.hide()">Cancel</a>
    </div>
  </div>
</p-overlayPanel>

<p-dialog
  header="Close Incident"
  [(visible)]="closeIncidentDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px', height: '250px' }"
>
  <form [formGroup]="closeIncidentForm">
    <div class="ui-g" style="position: relative; height: 180px">
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Reason</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            placeholder="Select closure reason..."
            formControlName="closureReasonId"
            [options]="closureReasons"
            [autoDisplayFirst]="false"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-4">
          <label>Notes</label>
        </div>
        <div class="ui-grid-col-8">
          <textarea
            name="notes"
            pInputTextarea
            style="width: 100%"
            maxlength="1024"
            rows="4"
            formControlName="closureNotes"
          ></textarea>
        </div>
      </div>
      <div class="ui-g-12">
        <button
          type="button"
          pButton
          icon="fa fa-close"
          (click)="clearClosureVars()"
          label="Cancel"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="button"
          pButton
          icon="fa fa-check"
          label="Ok"
          (click)="confirmCloseIncident()"
          class="ui-button btn-to-right green-btn"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
